<div class="detail-height">
  <div class="label-name text-style mb-1">Merchant Name</div>
  <div class="label-value text-style">
    {{ merchant_name ?? "-" }}
  </div>
</div>
<div class="detail-height">
  <div class="label-name text-style mb-1">Amount</div>
  <div class="label-value text-style">
    {{ amount ?? "-" }}
  </div>
</div>
<div class="detail-height">
  <div class="label-name text-style mb-1">Payment On</div>
  <div class="label-value text-style">
    {{ paymentDetails?.datetime_updated | date : "shortTime" }}
    -
    {{ paymentDetails?.datetime_updated | date : " EEE, MMM d, y" }}
  </div>
</div>
<div class="detail-height">
  <div class="label-name text-style mb-1">Referrence Number</div>
  <div class="label-value text-style">
    {{ reference ?? "-" }}
  </div>
</div>
